import type { UploadFile } from 'antd'

export const getFileType = (file: UploadFile) => {
    const fileType = file.type

    if (fileType?.startsWith('image/')) {
        return 'photo'
    } else if (fileType?.startsWith('video/')) {
        return 'video'
    } else if (fileType?.startsWith('application/')) {
        return 'document'
    } else if (file.type?.startsWith('audio/') && (file.type !== 'audio/ogg' || !file.name.endsWith('.ogg'))) {
        return 'audio'
    } else if (file.name.endsWith('.ogg')) {
        return 'voice-message'
    }
    return 'none'
}
